import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Lots.frontend.types'

@Injectable({ providedIn: 'root' })
export class Lots_create_lot_and_vendor_lotService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { materialId?: number, lotLookupCode?: string, vendorLotLookupCode?: string, lotStatusId?: number, expirationDate?: string, manufactureDate?: string }): Promise<{ LotId?: number, VendorLotId?: number }> 
  {
    let url = `${environment.backendUrl}api/Lots/functions/create_lot_and_vendor_lot`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

